import { Abacus } from "core/Abacus.Core";
import { Class } from "core/Abacus.Utilities";

class Detector extends Class {

    constructor(element) {
        super();
        this.element = $('body');
        this.getMetaData();
    }
    getMetaData() {
        var blockStatus = $("meta[name='blockthis']").attr("content");
        if (blockStatus) {
            if (!this.element.hasClass('unblocked')) {
                this.element.addClass(blockStatus);
                this.adTest();
            }
        }
    }

    adTest() {
        const test = document.createElement('div');
        test.innerHTML = '&nbsp;';
        test.className = 'adsbox';
        document.body.appendChild(test);
        window.setTimeout(() => {
            if (test.offsetHeight === 0) {
                this.prepareAlert();
                document.body.classList.add('adblock');
            }
            $(test).remove();
        }, 100);
    }

    prepareAlert() {
        var dupe = `<div data-url="/adblock.aspx"></div>`;
        $('body').append(dupe);
        this.alertOnScreen(dupe);
    }

    sendEvent(evt) {
        var evt = evt;

        dataLayer.push({
            'event': 'blockthis',
            'blockthisType': `${evt}`
        });

        if (typeof ga == 'function') {
            ga('clientTracker.send', 'event', {
                eventCategory: 'Adblock',
                eventAction: `blocked - ${evt}`,
                eventLabel: 'Adblock event',
                nonInteraction: true
            });
        }
    }

    alertOnScreen(dupe) {
        if (this.element.hasClass('blockGA')) {
            this.sendEvent('blockGA');
        }
        if (this.element.hasClass('blockComplete')) {
            this.sendEvent('blockComplete');
            $(window).trigger('abacus:loadPopupContent', [{
                popupStyles: {
                    klass: 'popupStyle1 detector'
                },
                useFixed: true,
                preventOverlayClosing: true,
                preventCloseButton: true,
                element: dupe
            }]);
        } else if (this.element.hasClass('blockPopup')) {
            this.sendEvent('blockPopup');
            $(window).trigger('abacus:loadPopupContent', [{
                popupStyles: {
                    klass: 'popupStyle1 detector'
                },
                useFixed: true,
                preventOverlayClosing: true,
                element: dupe
            }]);
        }
    }

}

export { Detector };


// WEBPACK FOOTER //
// ./Javascript/core/classes/popups/block.class.js